import useSWR from 'swr'

import { sharedStaticConfig } from '@ngb-frontend/shared/config'
import {
  BookingServiceCode,
  type Vehicle,
  type QueryConfig,
} from '@ngb-frontend/shared/types'

import { isLPSystem } from '../system/isSystem'

import type { RequestError } from '../error/RequestError'

export const useVehicle = (query?: QueryConfig) => {
  const { vehicleIdentifier, country, systemCode, service } = query || {}

  const isEoL = service === BookingServiceCode.EoL

  return useSWR<Vehicle, RequestError>(
    isLPSystem(systemCode) && vehicleIdentifier
      ? [
          sharedStaticConfig.apiRoutes.vehicle,
          { vehicleIdentifier, country, isEoL },
        ]
      : null,
  )
}
